import React from 'react';
import styled from '@emotion/styled';
import Carousel from 'react-multi-carousel';
import { Box, Button } from '@theme-ui/components'
import { FaChevronLeft, FaChevronRight} from 'react-icons/fa';

const LeftArrow = ({ onClick }) => (
  <CarouselArrowBTN
    onClick={onClick}
    sx={{left: -4}}
		aria-label='carousel-slide-right'
  >
    <FaChevronLeft size={32} color='#00A1F2' />
  </CarouselArrowBTN>
);

const RightArrow = ({ onClick }) => (
  <CarouselArrowBTN
    onClick={onClick}
    sx={{right: -4}}
		aria-label='carousel-slide-left'
  >
    <FaChevronRight size={32} color='#00A1F2' />
  </CarouselArrowBTN>
);

const CardSlider = ({
	children,
	customTransition = 'all 5000ms linear 0s',
	transitionDuration = 5000,
	arrows = true,
	className,
	itemClass,
	dotListClass,
	customResponsive,
	autoPlay = true,
	autoPlaySpeed = 1,
	showDots = false,
	renderButtonGroupOutside = true,
	partialVisible = true
}) => {
	const responsive = {
		superLargeDesktop: {
			breakpoint: { max: 4000, min: 1300 },
			items: 10,
		},
		desktop: {
			breakpoint: { max: 1299, min: 1024 },
			items: 6,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 3,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 2,
		},
	};

	return (
		<SliderWrapper className={className}>
			<Carousel
				ssr
				arrows={arrows}
				infinite
				autoPlay={autoPlay}
				autoPlaySpeed={autoPlaySpeed}
				containerClass='container-with-dots'
				customTransition={customTransition}
				focusOnSelect={false}
				itemClass={itemClass}
				keyBoardControl
				minimumTouchDrag={80}
				renderButtonGroupOutside={renderButtonGroupOutside}
				responsive={customResponsive ? customResponsive : responsive}
				showDots={showDots}
				renderDotsOutside={true}
				dotListClass={dotListClass}
				slidesToSlide={1}
				transitionDuration={transitionDuration}
				partialVisbile={partialVisible}
				customLeftArrow={<LeftArrow />}
				customRightArrow={<RightArrow />}>
				{children}
			</Carousel>
		</SliderWrapper>
	);
};

const SliderWrapper = styled(Box)`
  width: 100%;
  .slick-slide {
    padding: 0px 13px;
  }
  @media(max-width: 768px) {
    width: 100%;
  }
  position: relative;
  .react-multi-carousel-list {
    position: static !important;
  }
`;

const CarouselArrowBTN = styled(Button)`
	padding: 0;
	border: 0px solid pink;
	position: absolute;
	background-color: transparent;
	width: 43px;
	height: 43px;
	border-radius: 35px;
	text-align: center;
	:hover {
		background-color: transparent;
	}
	:focus,
	:active,
	:hover {
		box-shadow: none;
		outline: none;
	}
`;

export default CardSlider
